/**
 * Labstep
 *
 * @module screens/Authentication/Signup
 * @desc Signup Screen
 */

import { withUiPersistent } from 'labstep-web/containers/UiPersistent';
import { DocumentHead } from 'labstep-web/core/DocumentHead';
import { Columns } from 'labstep-web/screens/Authentication/Columns';
import { SignupLeft } from 'labstep-web/screens/Authentication/Signup/Left';
import { ScreensAuthenticationSignupRight as SignupRight } from 'labstep-web/screens/Authentication/Signup/Right';
import type React from 'react';
import type { ScreensAuthenticationSignupProps } from './types';

const QUOTE = {
  quote:
    'I can search my past experiments very fast and show others my work efficiently.',
  name: 'Chengwei Yuan',
  affiliation: 'University of Cambridge, UK',
};

export const ScreensAuthenticationSignup: React.FC<
  ScreensAuthenticationSignupProps
> = ({ uiPersistent }) => {
  const activeShareLink = uiPersistent.active_share_link;
  const header = activeShareLink
    ? ''
    : 'Sign up for Labstep Academia';
  const explainer = activeShareLink
    ? ''
    : 'Keep your research organised, accurate & accessible';
  return (
    <>
      <DocumentHead title="Signup" />
      <Columns
        inverted
        header={header}
        explainer={explainer}
        left={<SignupLeft bottomQuote={QUOTE} />}
        right={<SignupRight activeShareLink={activeShareLink} />}
        centerAlign={false}
      />
    </>
  );
};

export default withUiPersistent(ScreensAuthenticationSignup);
